module.exports = __webpack_public_path__ + "static/media/MENOSPHLIQUIDO.c6134839.png";